import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';
import { EXCEPTION_SUB_CATEGORIES_ACTION_TYPE } from 'store/system/actions';

const initialState = {
  data: {},
};

const exceptionSubCategoriesReducer = (state = initialState, { payload, type, meta }) => {
  switch (type) {
    case EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.GET_LIST:
      return { ...state, data: payload || initialState.data };

    case EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.CREATE:
    case EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.EDIT:
      return { ...state, data: { ...state.data, [payload.id]: payload } };

    case EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.DELETE:
      return { ...state, data: _.omit(state.data, meta.id) };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default exceptionSubCategoriesReducer;
